export enum FlagKey {
  CALCULATOR_ASSISTANT = "calculator-assistant",
  CALCULATOR_UNLIMITED_USAGE = "calculator-unlimited-usage",
  MACHINE_SELECTION_UI = "machine-selection-ui",
  MAINTENANCE_BANNER = "maintenance-banner",
  V1_API_ENABLED = "enable-api-endpoints",
}

// Flags exposed by the mobile bootstrap API.
export type FeatureFlags = Record<FlagKey.CALCULATOR_UNLIMITED_USAGE, boolean>;

export type FeatureFlagUser = {
  id: string;
  email?: string | null;
};

export const CLIENT_FEATURE_FLAG_DEFAULTS = {
  [FlagKey.CALCULATOR_ASSISTANT]: false,
  [FlagKey.CALCULATOR_UNLIMITED_USAGE]: false,
  [FlagKey.MACHINE_SELECTION_UI]: false,
};

export type ClientFlagKey = keyof typeof CLIENT_FEATURE_FLAG_DEFAULTS;
export type ClientFeatureFlags = Record<ClientFlagKey, boolean>;
